/*
  Program Description:
  - This file contains the chart configuration.
  - It is used in the Reports Generation.
*/
function truncateString (str, num) {
  if (str.length <= num) return str
  return str.slice(0, num) + '...'
}

function generateLegends (chart, withPercentage, isExport) {
  const { extraData, labels } = chart.data
  const { data, backgroundColor } = chart.data.datasets[0]
  const total = data.reduce((a, b) => a + b, 0)
  const legends = labels.map((label, index) => {
    const value = data[`${index}`]
    const percentage = ((value / total) * 100).toFixed(2)
    const percentText = withPercentage ? `(${percentage}%)` : ''
    const extraText = extraData && extraData.labels && extraData.labels[`${index}`]
    const text = `${label || extraText} (${value})${percentText}`
    const fillStyle = backgroundColor && backgroundColor[`${index}`]
    const canTruncateString = text.length > 80 && !isExport
    return {
      text: canTruncateString ? truncateString(text, 80) : text,
      value,
      fillStyle,
      tooltip: text
    }
  })
  if (extraData && extraData.voluntary) {
    legends.push({ value: true, text: `Voluntary: ${extraData.voluntary}` })
    legends.push({ value: true, text: `Mandatory: ${extraData.mandatory}` })
  }
  legends.push({ value: true, text: `Total: ${total}` })
  return legends.filter(legend => legend.value)
}

export default function (type, vm) {
  const isExport = type === 'exportPDBNF' || type === 'exportASIR'
  const padding = {
    asir: {
      top: 10,
      bottom: 70,
      right: 80,
      left: 80
    },
    pdbnf: {
      top: 10,
      bottom: 70,
      right: 80,
      left: 80
    },
    exportPDBNF: {
      top: 10,
      bottom: 10,
      right: 20,
      left: 20
    },
    exportASIR: {
      top: 10,
      bottom: 10,
      right: 20,
      left: 20
    }
  }
  return {
    barOptions: {
      graphType: 'bar',
      options: {
        animation: {
          duration: 0
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            precision: 0
          }
        }]
      },
      plugins: {
        datalabels: {
          color: 'black',
          font: {
            size: 14
          }
        },
        labels: {
          precision: 2
        }
      },
      legend: {
        display: true,
        position: 'top',
        labels: {
          boxWidth: 20,
          generateLabels: chart => {
            const legends = generateLegends(chart, false, isExport)
            // remove bar chart label
            chart.data.labels = chart.data.labels.map(_ => '')
            return legends
          }
        },
        onHover: function (event, { tooltip }) {
          vm.tooltip = tooltip
          vm.tooltipStyle.top = (event.pageY - 100) + 'px'
          vm.tooltipStyle.left = (event.pageX - 350) + 'px'
        },
        onLeave: function () {
          vm.tooltip = ''
        }
      },
      responsive: true,
      maintainAspectRatio: false
    },
    pieOptions: {
      plugins: {
        outlabels: {
          display: false
        },
        datalabels: {
          color: 'black',
          display: 'auto',
          align: 'start',
          anchor: 'end',
          formatter: function (value, context) {
            const { dataset } = context
            const sum = dataset.data.reduce((x, y) => x + y, 0)
            const percentage = ((value / sum) * 100).toFixed(2) + '%'
            return value ? `${value} (${percentage})` : ''
          }
        }
      },
      tooltips: {
        callbacks: {
          label: function (item, graphData) {
            const data = graphData.datasets[0].data
            const filteredData = data.filter(Boolean)
            const total = filteredData.reduce((partialSum, a) => partialSum + a, 0)
            const percentage = (data[`${item.index}`] / total) * 100
            const labelName = graphData.labels[`${item.index}`]
            return `${labelName} (${data[`${item.index}`]})(${percentage.toFixed(2)}%)`
          }
        }
      },
      layout: {
        padding: padding[`${type}`]
      },
      legend: {
        display: true,
        position: 'top',
        labels: {
          boxWidth: 20,
          generateLabels: function (chart) {
            return generateLegends(chart, true, isExport)
          }
        },
        onHover: function (event, { tooltip }) {
          vm.tooltip = tooltip
          vm.tooltipStyle.top = (event.pageY - 100) + 'px'
          vm.tooltipStyle.left = (event.pageX - 350) + 'px'
        },
        onLeave: function () {
          vm.tooltip = ''
        }
      },
      responsive: true,
      maintainAspectRatio: true
    },
    graphColors: [
      '#4e79a7',
      '#f28e2b',
      '#e15759',
      '#76b7b2',
      '#59a14f',
      '#edc948',
      '#48edda',
      '#ff9da7',
      '#9c755f',
      '#bab0ac',
      '#b3de4e',
      '#7153ad',
      '#752d41',
      '#8c7441',
      '#7b14c8',
      '#2ec68e',
      '#246b57'
    ]
  }
}
